import { render, staticRenderFns } from "./v-select-basic.vue?vue&type=template&id=f66545ac&scoped=true&"
import script from "./v-select-basic.vue?vue&type=script&lang=js&"
export * from "./v-select-basic.vue?vue&type=script&lang=js&"
import style0 from "./v-select-basic.vue?vue&type=style&index=0&id=f66545ac&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f66545ac",
  null
  
)

export default component.exports